import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from "vuex";
import { Fragment } from "vue-fragment";
import { typeToUsableComponent } from "../mixins/component-selector";
import { IS_EMAIL_SYNCED, EMAIL_SIGNATURE } from "../store/automation-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ActionArguments",
  components: {
    Fragment
  },
  mixins: [typeToUsableComponent],
  props: {
    action: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      default: () => ({})
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    editing: {
      type: Boolean,
      default: false
    },
    triggerArguments: {
      type: Object,
      default: () => ({})
    },
    trigger: {
      type: Object,
      default: () => ({})
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("AutomationStore", [IS_EMAIL_SYNCED, EMAIL_SIGNATURE])), mapState("AutomationStore", ["currentAutomation"])), {}, {
    boardId() {
      const {
        board
      } = this.triggerArguments;
      if (board && Array.isArray(board)) {
        return board.length && board[0].value;
      }
      return board && board.value;
    },
    actionArguments() {
      var _context;
      return _filterInstanceProperty(_context = this.action["action-arguments"]).call(_context, ({
        type
      }) => (type !== "assignees" || this.boardId) && type !== "title");
    }
  }),
  methods: {
    handleInput(value, id) {
      const inputValue = id === "checklist" ? value : {
        [id]: value
      };
      this.$emit("input", _objectSpread(_objectSpread({}, this.value), inputValue));
    },
    componentProps(arg) {
      switch (arg.type) {
        case "multi-option":
          return {
            items: _valuesInstanceProperty(arg)
          };
        case "email":
          return {
            emailSynced: this.IS_EMAIL_SYNCED,
            emailSignature: this.EMAIL_SIGNATURE,
            owner: this.currentAutomation.owner,
            referrerEmail: this.action.key == "referrer-email"
          };
        case "assignees":
          return {
            boardId: this.boardId
          };
        case "assignees-single":
          return {
            multiple: true,
            boardId: this.boardId
          };
        case "time":
          return {
            defaultValue: _valuesInstanceProperty(arg),
            id: arg.id,
            label: this.$t("global.words.time"),
            hiddenLabel: true
          };
        case "checklist":
          return {
            checklist: this.value["checklist"],
            title: this.value["title"]
          };
        default:
          return {};
      }
    }
  }
});